import React, { ReactNode, useEffect, useState } from "react";
import { Button } from "antd";

export interface ModalProps {
  className?: string;
  headerClassName?: string;
  titleClassName?: string;
  buttonClassName?: string;
  cancelButtonClassName?: string;
  closeButtonClassName?: string;
  footerClassName?: string;
  contentContainerClassName?: string;
  style?: React.CSSProperties;
  isModalOpen: boolean;
  handleOpenModal: () => void;
  handleCloseModal: () => void;
  children: ReactNode;
  formClassName?: string;
  inputClassName?: string;
  inputSuffixIconColor?: string;
  selectDropdownStyle?: React.CSSProperties;
  selectIconStyle?: React.CSSProperties;
  headerTitle?: string;
  disabled?: boolean;
  onSave: () => Promise<any>;
  onError?: (error: any) => void;
}

export function useModal(initialIsModalOpen?: boolean) {
  const [isModalOpen, setIsModalOpen] = useState(initialIsModalOpen || false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  }

  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isModalOpen) {
        handleCloseModal();
      }
    };

    document.addEventListener('keydown', handleEscKey);
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isModalOpen]);

  return { isModalOpen, handleOpenModal, handleCloseModal };
}

export interface ModalFooterProps {
  onSave: () => Promise<any>;
  handleCloseModal: () => void;
  altAction?: ReactNode;
  modalFooterClassName?: string;
  modalButtonClassName?: string;
  modalCancelButtonClassName?: string;
  disabled?: boolean;
}

export const ModalFooter = ({ onSave, handleCloseModal, altAction, modalFooterClassName, modalButtonClassName, modalCancelButtonClassName, disabled }: ModalFooterProps) => {
  return (
    <div className={`flex justify-between gap-2 p-[24px] ${modalFooterClassName}`}>
      {altAction ? altAction : <div className="flex-grow"></div>}
      <div className="flex justify-end gap-[16px]">
        <Button type="default" size="large" onClick={handleCloseModal} className={modalCancelButtonClassName}>
          Cancel
        </Button>
        <Button
          type="primary"
          className={modalButtonClassName}
          size="large"
          onClick={onSave}
          disabled={disabled}
        >
          Save changes
        </Button>
      </div>
    </div>
  );
};

